import "core-js/modules/es.array.reverse.js";
var _class, _DateParameter;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import FunctionParameter from "./FunctionParameter";
import { makeObservable, override } from "mobx";
import moment from "moment";
let DateParameter = (_class = (_DateParameter = class DateParameter extends FunctionParameter {
  constructor(catalogFunction, options) {
    super(catalogFunction, options);
    this.catalogFunction = catalogFunction;
    _defineProperty(this, "type", "date");
    _defineProperty(this, "variant", "complex");
    _defineProperty(this, "clock", void 0);
    this.clock = options.clock;
    makeObservable(this);
  }

  /**
   * Return current date value.
   *
   * When no value is available and the field is marked as required, then
   * return the current timeline clock date.
   */
  get value() {
    var _super$value;
    return (_super$value = super.value) !== null && _super$value !== void 0 ? _super$value : this.isRequired ? this.currentClockDate() : undefined;
  }

  /**
   * Validate and set datetime value
   */
  setValue(stratumId, newValue) {
    super.setValue(stratumId, this.isValidDate(newValue) ? newValue : undefined);
  }
  isValidDate(value) {
    const date = new Date(value);
    return date instanceof Date && !isNaN(date.valueOf());
  }

  /**
   * Returns current clock time in local time zone.
   */
  currentClockDate() {
    const currentTime = this.clock.currentTime;
    const ct = new Date(currentTime.toString());
    const date = moment.utc(ct.toISOString()).local().format("YYYY-MM-DD");
    return date;
  }

  /**
   * Process value so that it can be used in an URL.
   */
  static formatValueForUrl(value) {
    return JSON.stringify({
      type: "object",
      properties: {
        timestamp: {
          type: "string",
          format: "date",
          date: value
        }
      }
    });
  }
}, _defineProperty(_DateParameter, "type", "date"), _DateParameter), _applyDecoratedDescriptor(_class.prototype, "value", [override], Object.getOwnPropertyDescriptor(_class.prototype, "value"), _class.prototype), _class);
export { DateParameter as default };